<!-- ------------------Page Heading Start------------- -->

<div class="page_heading">
    <div class="container">
        <h2>Our Portfolio</h2>
    </div>
</div>

<!-- ------------------Page Heading End------------- -->
<!-- -------------------------Gallery Section Start----------------- -->


<section class="portfolio_section">
    <div class="container">
        <!-- <div class="row"> -->
            <mat-tab-group (selectedTabChange)="onTabChange($event)">
                <mat-tab label="Website">
                    <div class="container py-5">
                        <div class="row">
                          <ng-container *ngFor="let card of webCard">
                          <div
                            *ngIf="card?.visibility"
                            class="col-xl-4 col-sm-4 col-md-6 col-4 col-12 mb-4 "
                          >
                            <div class="our-product-card">
                              <div class="product_card" [ngStyle]="getUrl(card)"></div>
                              <div class="card-body">
                                <h5 class="card-title">
                                  {{
                                    card.tittle.length > 28
                                      ? card.tittle.substring(0, 28) + "..."
                                      : card.tittle
                                  }}
                                </h5>
                                <p class="card-text">{{ card.details }}</p>
                               
                                <!-- <a class="btn btn-primary buy_btn" (click)="gotoDetail(card)">View More Details</a> -->
                              </div>
                            </div>
                          </div>
                        </ng-container>
                          <!-- </div> -->
                        </div>
                        
                      </div>
                </mat-tab>
                <mat-tab label="Mobile">
                  <div class="container py-5">
                    <div class="row">
                      <ng-container *ngFor="let card of mobilecards">
                      <div
                         *ngIf="card?.visibility"
                        class="col-xl-4 col-sm-4 col-md-6 col-4 col-12 mb-4 "
                      >
                        <div class="our-product-card">
                          <div class="product_card" [ngStyle]="getUrl(card)"></div>
                          <div class="card-body">
                            <h5 class="card-title">
                              {{
                                card.tittle.length > 28
                                  ? card.tittle.substring(0, 28) + "..."
                                  : card.tittle
                              }}
                            </h5>
                            <p class="card-text">{{ card.details }}</p>
                           
                            <!-- <a class="btn btn-primary buy_btn" (click)="gotoDetail(card)">View More Details</a> -->
                          </div>
                        </div>
                      </div>
                    </ng-container>
                      <!-- </div> -->
                    </div>
                    
                  </div>
                </mat-tab>
                <mat-tab label="Social Media Mangement ">
                    <!-- <p>test 3</p> -->
                    <div class="container py-5">
                      <div class="row">
                        <ng-container *ngFor="let card of ssmCards">
                        <div
                          *ngIf="card?.visibility"
                          class="col-xl-4 col-sm-4 col-md-6 col-4 col-12 mb-4 "
                        >
                          <div class="our-product-card">
                            <div class="product_card" [ngStyle]="getUrl(card)"></div>
                            <div class="card-body">
                              <h5 class="card-title">
                                {{
                                  card.title.length > 28
                                    ? card.title.substring(0, 28) + "..."
                                    : card.title
                                }}
                              </h5>
                              <p class="card-text">{{ card.details }}</p>
                             
                              <!-- <a class="btn btn-primary buy_btn" (click)="gotoDetail(card)">View More Details</a> -->
                            </div>
                          </div>
                        </div>
                      </ng-container>
                        <!-- </div> -->
                      </div>
                      
                    </div>
                </mat-tab>
            </mat-tab-group>
        <!-- </div> -->
    </div>
</section>